module.exports = __webpack_public_path__ + "assets/img/11_735_big.5bf8beb6.jpg";